var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrivy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M65.469 5.431 10.124 37.409l.001 64.468 55.337 32.232 55.351-32.214V37.407z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1904DA",
    d: "M63.957 92.94V79.575c-6.048-2.856-9.846-8.792-9.768-15.27l-12.456-7.193c-.783 7.101.852 14.447 4.636 20.771 4.176 6.977 10.091 12.04 17.588 15.057z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1904DA",
    d: "M63.957 111.255V95.742c-8.438-3.162-15.089-8.73-19.77-16.553-4.275-7.141-5.989-15.458-4.842-23.457l-11.564-6.678c-6.641 25.598 8.789 52.132 36.176 62.201z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#08B1D5",
    d: "M66.804 95.596v15.649c26.877-10.306 42.715-37.348 36.372-62.1l-11.488 6.693c1.481 8.635.079 16.879-4.065 23.865-4.147 6.994-11.342 12.485-20.819 15.893z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#08B1D5",
    d: "M66.804 79.551v13.402c8.456-3.219 14.89-8.239 18.632-14.548 3.675-6.197 5.016-13.512 3.896-21.2L76.888 64.38c-.062 6.15-3.717 11.652-10.084 15.171z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC900",
    d: "M78.53 41.442c5.228 2.549 9.501 6.608 12.373 11.749l11.183-6.458a6.201 6.201 0 0 1-.211-.316c-4.4-7.116-10.209-12.47-17.267-15.913-19.641-9.576-44.026-2.441-55.772 16.23l11.227 6.481c8.407-13.064 25.205-18.24 38.467-11.773z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC900",
    d: "M65.771 55.646c1.762 0 3.527.385 5.182 1.193h.001a11.868 11.868 0 0 1 5.158 4.894l12.588-7.27c-2.618-4.7-6.516-8.409-11.285-10.735-12.078-5.888-27.409-1.16-35.147 10.76l12.525 7.229c2.604-3.881 6.779-6.071 10.978-6.071z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#08B1D5",
    d: "m66.804 130.848 51.828-30.205V40.14l-13.177 7.677c7.242 26.586-9.654 55.513-38.651 66.142v16.889z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1904DA",
    d: "m25.5 47.738-13.196-7.621v60.509l51.653 30.22v-16.883c-29.055-10.227-45.87-39.19-38.457-66.225z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC900",
    d: "M85.722 28.218c7.498 3.656 13.661 9.329 18.316 16.859.074.12.164.245.263.376l13.056-7.539L65.469 7.948l-51.9 29.973 13.061 7.54c12.412-19.817 38.266-27.399 59.092-17.243z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0036",
    d: "M74.264 64.806a15.53 15.53 0 0 0-.015-1.301c-.104-.324-1.328-2.715-4.385-4.383-2.089-1.139-4.769-1.27-7.357-.362-2.536.891-4.688 2.664-5.922 4.873-.015.192-.044.647-.022 1.173.167 4.129 2.721 9.743 7.931 12.311l.802.383.696-.372c5.063-2.834 8.078-7.325 8.272-12.322z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivy);
export default __webpack_public_path__ + "static/media/trivy.00e559a40dcd49e5b7bbe9afabda373c.svg";
export { ForwardRef as ReactComponent };